"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleKnappPurePropsShape = void 0;
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
require("nav-frontend-toggle-style");
const knappCls = (props) => (0, classnames_1.default)("toggleKnapp", {
    "toggleKnapp--pressed": props.pressed,
    "toggleKnapp--kompakt": props.kompakt,
});
class ToggleKnappPure extends React.PureComponent {
    render() {
        const renderProps = (0, nav_frontend_js_utils_1.omit)(this.props, "children", "pressed", "kompakt", "isRequired");
        const knappId = (0, nav_frontend_js_utils_1.guid)();
        return (React.createElement("button", Object.assign({ type: "button", id: knappId, className: knappCls(this.props), "aria-pressed": this.props.pressed }, renderProps), this.props.children));
    }
}
ToggleKnappPure.defaultProps = {
    pressed: false,
};
exports.ToggleKnappPurePropsShape = PT.shape({
    /**
     * Content
     */
    children: PT.oneOfType([PT.arrayOf(PT.node), PT.node]),
    /**
     * Pressed state
     */
    pressed: PT.bool,
    /**
     * Kompakt versjon
     */
    kompakt: PT.bool,
    /**
     * Custom onChange handler
     */
    onChange: PT.func,
}).isRequired;
ToggleKnappPure.propTypes = exports.ToggleKnappPurePropsShape;
exports.default = ToggleKnappPure;
